import { UserStatusEnum } from "../../enums/user-status.enum";

export class SearchAppUserModel {
    public name: string = '';
    public asc: boolean = true;  
    public status : number = UserStatusEnum.All;
    public city: string = '';
    public pageSize: number = 10;
    public pageNumber: number = 1;
}